// src/components/about/Stats.jsx
const stats = [
  { number: "1,200+", label: "Happy Clients" },
  { number: "30+", label: "Years of Experience" },
  { number: "70+", label: "Expert Doctors & Staff" },
  { number: "340+", label: "Online Appointments" },
];

const Stats = () => (
  <section className="py-16 bg-blue-900 text-white">
    <div className="container mx-auto px-4">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
        {stats.map((stat, index) => (
          <div key={index}>
            <div className="text-4xl md:text-5xl font-bold mb-2">{stat.number}</div>
            <div className="text-blue-200">{stat.label}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Stats;